import { StatusChipText } from '@labrav/react-components'

import {
  DisbursementStatus,
  disbursementStatusMap,
} from '../../modules/revenueInsightsV2/types'
import { getKeyFromValue } from './getKeyFromValue'

export const getStatusAndLabelForRevenueInsights = (
  status: DisbursementStatus
) => {
  const statusLabel = getKeyFromValue(status)(disbursementStatusMap)
  switch (status) {
    case DisbursementStatus.NOT_DISBURSED:
      return { textColor: StatusChipText.RED, label: statusLabel as string }
    case DisbursementStatus.DISBURSED:
      return { textColor: StatusChipText.GREEN, label: statusLabel as string }
    default:
      return { textColor: StatusChipText.RED, label: statusLabel as string }
  }
}
